export default __webpack_public_path__ + "static/media/DashboardOffers.04e0a4f0.svg";